import type { Organization } from 'src/types/Organization';
import type { PaginatedListResponse } from 'src/api/response_models/PaginatedListIResponse';
import { api } from './api';
export const organizationApi = api.injectEndpoints({
  endpoints: builder => ({
    getOrganizationList: builder.query<
      PaginatedListResponse<Organization>,
      {
        page?: number;
        pageSize?: number;
        searchText?: string;
      }
    >({
      query: ({ page, pageSize, searchText }) => ({
        url: `/organizations/`,
        method: 'GET',
        params: {
          page: page ?? 1,
          page_size: pageSize ?? 100,
          search: searchText,
        },
      }),
    }),
    createOrganization: builder.mutation<Organization, { name: string }>({
      query: organization => ({
        url: `/organizations/`,
        method: 'POST',
        body: organization,
      }),
    }),
    updateOrganization: builder.mutation<Organization, { organization_id: string; data: Partial<Organization> }>({
      query: ({ organization_id, data }) => ({
        url: `/organizations/${organization_id}/`,
        method: 'PUT',
        body: data,
      }),
    }),
    deleteOrganization: builder.mutation<Organization, { organization_id: string }>({
      query: ({ organization_id }) => ({
        url: `/organizations/${organization_id}/`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetOrganizationListQuery,
  useCreateOrganizationMutation,
  useUpdateOrganizationMutation,
  useDeleteOrganizationMutation,
} = organizationApi;
